import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-08894d48"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home-page-block-info-wrap" }
const _hoisted_2 = { class: "home-page-block-info" }

import {BlockItemTab} from "@/entities";
import {onBeforeMount, ref} from "vue";
import {
  fintech_startup,
  goverment_and_lending_institutions,
  retail_chains_and_small_markets,
  HelpModel,
  useLocalizationStore,
} from "@/shared";


export default /*#__PURE__*/_defineComponent({
  __name: 'home-page-block-info',
  setup(__props) {

const {translate} = useLocalizationStore();

onBeforeMount(() => {
  initArrData();
});

const arrData = ref<Array<HelpModel>>(new Array<HelpModel>());

const initArrData = () => {
  arrData.value.push(new HelpModel({
    Text: "startups_neobankings",
    Image: fintech_startup,
  }));
  arrData.value.push(new HelpModel({
    Text: "lending_institutions",
    Image: goverment_and_lending_institutions,
  }));
  arrData.value.push(new HelpModel({
    Text: "retail_chains_small_markets",
    Image: retail_chains_and_small_markets,
  }));
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(arrData.value, (item, ind) => {
        return (_openBlock(), _createBlock(_unref(BlockItemTab), {
          key: ind,
          image: item.Image,
          text: _unref(translate)(item.Text),
          class: "blue"
        }, null, 8, ["image", "text"]))
      }), 128))
    ])
  ]))
}
}

})